import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import useOrdersList from './useOrdersList';
import useProductGroups from './useProductGroups';
import selectBrodMigdal from '../../../../../../generic/utils/selectBrodMigdal';

const useOrderCustomer = () => {
    const ordersList = useOrdersList();
    const productGroups = useProductGroups();

    const defaults = useSelector((s: any) => s.defaults?.defaults);
    const dayJump = useSelector(
        (s: any) => s.defaults?.defaults?.filter((e: any) => e.Int_ID === 338)[0],
    ) || 0;
    const isBlockCreateOrder = !!selectBrodMigdal(defaults, 614, 'Logical_Value');

    const [date, setDate] = useState<any>();
    const [selectedDateStart, setSelectedDateStart] = useState<string | null>(null);
    const [selectedDateEnd, setSelectedDateEnd] = useState<string | null>(null);
    const [filterGoodName, setFilterGoodName] = useState('');
    const [innerTime, setInnerTime] = useState('');
    const [isOpenLogs, setIsOpenLogs] = useState(false);

    const handleOpenLogs = useCallback(() => {
        setIsOpenLogs(prev => !prev);
    }, []);

    useEffect(() => {
        if (!selectedDateEnd) return;
        ordersList.loadOrders(selectedDateStart as string, selectedDateEnd);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedDateEnd]);

    return {
        ...ordersList,
        ...productGroups,
        date,
        setDate,
        selectedDateStart,
        setSelectedDateStart,
        selectedDateEnd,
        setSelectedDateEnd,
        filterGoodName,
        setFilterGoodName,
        innerTime,
        setInnerTime,
        isOpenLogs,
        handleOpenLogs,
        dayJump,
        isBlockCreateOrder,
    };
};

export default useOrderCustomer;
